import React from 'react'
import { useDataContext } from "context/DataContext"
import DefaultCard from 'components/card/DefaultCard'
import { useTranslation } from 'react-i18next'
import './MetaInfo.scss'

const MetaInfo: React.FC = () => {
    const { t } = useTranslation('common')
    const {tumor, fileName} = useDataContext()

    const primaryTumorSite = tumor?.primaryTumorSite?.trim() || ''
    const histologyType = tumor?.histologyType?.trim() || ''
    const tumorset = [primaryTumorSite, histologyType].filter(Boolean).join(', ')

    const tumorsetMissing = !primaryTumorSite || !histologyType

    return (
        <DefaultCard className='metaInfoCard'>
            <div className='metaInfoRow'>
                <div className='metaInfoItem'>
                    <div className='metaInfoLabel'>{t('metaInfo.tumorset')}</div>
                    <div className='metaInfoValue' title={tumorset}>{tumorset}</div>
                    {tumorsetMissing && (
                        <div className="metaInfoError">{t('metaInfo.tumorsetMissing')}</div>
                    )}
                </div>
                <div className='metaInfoItem'>
                    <div className='metaInfoLabel'>{t('metaInfo.fileName')}</div>
                    <div className='metaInfoValue' title={fileName}>{fileName}</div>
                </div>
            </div>
        </DefaultCard>
    )
}

export default MetaInfo